// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { SPAAuthService } from '../../core/services/spa-auth.service';
import {
  FlagsService,
  CoreState,
  AllowedRoutes,
  selectAllowedRoutes,
  ACCOUNT_SETTINGS_ROUTE,
  IAM_ROUTE
} from '@app/core';

const MEMBERSHIP_LABEL = 'Membership';

interface NavLink {
  label: string;
  route: string[];
  nucleoIcon?: string;
  assetIcon?: string;
  routerLinkActiveOptions?: any;
}

interface NavSection {
  label: string;
  links: NavLink[];
}

const navSections: NavSection[] = [
  {
    label: 'My Accounts',
    links: [
      {
        label: 'Dashboard',
        assetIcon: '_ionicons_svg_md-home.svg',
        route: ['/', IAM_ROUTE, 'home'],
        routerLinkActiveOptions: { exact: true }
      },
      {
        label: 'Roles',
        nucleoIcon: 'badge',
        route: ['/', IAM_ROUTE, 'roles']
      },
      // {
      //   label: 'Groups',
      //   assetIcon: '_ionicons_svg_md-people.svg',
      //   route: ['/', IAM_ROUTE, 'groups']
      // },
      {
        label: 'Users',
        assetIcon: '_ionicons_svg_md-person.svg',
        route: ['/', IAM_ROUTE, 'users']
      },
      {
        label: 'Organizations',
        nucleoIcon: 'building',
        route: ['/', IAM_ROUTE, 'organizations']
      },
      {
        label: 'Policies',
        assetIcon: '_ionicons_svg_md-apps.svg',
        route: ['/', IAM_ROUTE, 'policies']
      }
      // {
      //   label: 'Settings',
      //   assetIcon: '_ionicons_svg_md-settings.svg',
      //   route: ['/', ACCOUNT_SETTINGS_ROUTE]
      // }
    ]
  },
  {
    label: MEMBERSHIP_LABEL,
    links: [
      {
        label: 'Joined',
        route: []
      },
      {
        label: 'Join a new project',
        route: ['/', 'projects'],
        routerLinkActiveOptions: { exact: true }
      },
      {
        label: 'Settings',
        route: ['/', 'projects', 'settings']
      }
    ]
  }
];

@Component({
  selector: 'app-nav-panel',
  templateUrl: './nav-panel.component.html',
  styleUrls: ['./nav-panel.component.scss']
})
export class NavPanelComponent implements OnInit {
  navSections$: Observable<NavSection[]>;
  shouldShowMembershipBlock: boolean;

  constructor(private auth: SPAAuthService, store: Store<CoreState>, flagService: FlagsService) {
    this.shouldShowMembershipBlock = flagService.allowed('FLAG_MEMBERSHIPS');
    const sections = navSections.filter(section => this.shouldShowSection(section));
    this.navSections$ = store.pipe(select(selectAllowedRoutes)).pipe(
      map((allowedRoutes: AllowedRoutes) =>
        sections.map(section => ({
          ...section,
          links: this.filterAllowedLinks(section, allowedRoutes)
        }))
      )
    );
  }
  ngOnInit() {}

  sectionIdxLabel(idx: number) {
    return `section_${idx}`;
  }

  linkIdxLabel(idx: number) {
    return `link_${idx}`;
  }

  logout() {
    this.auth.logout();
  }

  private shouldShowSection({ label }: NavSection) {
    return (label === MEMBERSHIP_LABEL && this.shouldShowMembershipBlock) || label !== MEMBERSHIP_LABEL;
  }

  private filterAllowedLinks({ links }: NavSection, allowedRoutes: AllowedRoutes) {
    return links.filter(link => link.route.some((partialRoute: string) => allowedRoutes[partialRoute]));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/nav-panel/nav-panel.component.ts